export default {
  title: {
    thirdIntegrationConfigManagementTitle: '第三方集成配置管理'
  },
  label: {
    aiInterviewConfigTitle: 'AI面试配置',
    aiInterviewServiceProvider: 'AI面试服务提供商',
    appKey: 'APP Key',
    appSecret: 'APP Secret',
    appSalt: 'Salt',
    appUniqueCode: 'Unique Code',
    appId: 'APP ID',
    appToken: 'Token',
    appCode: 'Code',
    serverUrl: '服务Url',
    appMsgSecret: '消息 Secret',
    aiInterviewCallbackUrl: '回调Url'
  },
  SERVICE_PROVIDER: {
    DUO_MIAN: '多面AI',
    HRTPS: 'HRTPS'
  }
}
